import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCivicrmComponent } from './simple-icons-civicrm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCivicrmComponent ],
    exports:      [ SimpleIconsCivicrmComponent ],
    bootstrap:    []
})
export class SimpleIconsCivicrmModule {}
